// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__kBoYO","spin":"Loader_spin__1WXWj"};